module.exports = __webpack_public_path__ + "static/media/jian-detail-title-icon.dd83321d.png";